
export default function getFilterValuesFromQueryString(searchParams, configurations) {
    let queryParams = new URLSearchParams(searchParams)
    let urlFilterValues = null
    queryParams.forEach((value, key) => {
        // Only ingest query params that belong to this page's filter
        // configurations (nested/flattened keys like "dateRange.start" are
        // matched by their base name), plus the special "searchTerm" key.
        // This keeps foreign/unrelated params -- e.g. the Advanced Filters
        // "filter" param (base64 state, see Filters/filterUrl.js) or other
        // deep-link params -- out of legacy filterValues state.
        const baseName = key.split(".")[0]
        const config = configurations.find(setting => setting.name === baseName)
        if (!config && baseName !== "searchTerm") {
            return
        }

        if (urlFilterValues === null) {
            urlFilterValues = {}
        }
        if (value.includes(",")) {
            urlFilterValues[key] = value.split(',').map(item => (+item).toString() === item ? +item : item)
        } else {
            if (config && config.type === "select" && config.isMulti) {
                urlFilterValues[key] = [(+value).toString() === value ? +value : value]
            } else {
                urlFilterValues[key] = value === "true" || value === "false" ? value.toLowerCase() === "true" : (+value).toString() === value ? +value : value
            }
        }
    })

    return urlFilterValues
}